import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
import Label from './Label';
import ErrorLabel from './ErrorLabel';
const Checkbox = ({ id, label, children, checked, info, helptext, onChange, disabled, className, inputClassNames, error, style, hideLabel, name, dataTestId, }) => {
    function handleChange(e) {
        onChange(e.target.checked);
    }
    let body;
    if (label) {
        body = label;
    }
    else if (children) {
        body = children;
    }
    function renderErrorMessage() {
        if (!(error && error.message)) {
            return null;
        }
        return (React.createElement(ErrorLabel, { dataTestId: "ErrorLabel-ca603a1c", className: "mt-1 mb-4" }, error.message));
    }
    const hasLabel = !hideLabel && body;
    const containerClassName = getClassName('relative', {
        flex: hasLabel,
        'items-center': hasLabel,
    }, className);
    const labelClassName = getClassName({
        'ml-2': hasLabel,
        'text-sm': hasLabel,
    });
    return (React.createElement("div", { "data-testid": dataTestId, className: containerClassName, style: style },
        React.createElement("div", { "data-testid": "div-8b0affe4", className: "flex items-center h-5" },
            React.createElement("input", { "data-testid": `checkBox-${name}`, type: "checkbox", id: id, checked: checked, disabled: disabled, onChange: handleChange, className: `w-4 h-4 border-gray-200 border-solid rounded text-green focus:ring-green ${inputClassNames}` })),
        (hasLabel || helptext) && (React.createElement("div", { "data-testid": "div-7f760401", className: labelClassName },
            body && (React.createElement(Label, { dataTestId: "Label-b42460ae", htmlFor: id, className: "font-medium text-gray-700", helptext: info }, body)),
            helptext && helptext)),
        renderErrorMessage()));
};
Checkbox.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    hideLabel: PropTypes.bool,
    label: PropTypes.string,
    children: PropTypes.any,
    helptext: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    inputClassNames: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    style: PropTypes.object,
    error: PropTypes.object,
};
Checkbox.defaultProps = {
    hideLabel: false,
    checked: false,
    disabled: false,
    error: {},
};
export default Checkbox;
